export enum CruiseDifficulty {
  TRIVIAL = "TRIVIAL",
  EASY = "EASY",
  MEDIUM = "MEDIUM",
  HARD = "HARD",
  EXTREME = "EXTREME"
}